import { Box, Button, Image, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import error from '../../assets/errorandloading/21.png'

const Error = () => {
  const navigate = useNavigate();
  const bg = useColorModeValue("#f2eee8", "gray.800");

  return (
    <Box
      bg={bg}
      minH="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      px={4}
    >
      <Stack spacing={6} textAlign="center">
        <Stack direction="row" justify="center" align="center" spacing={0} fontSize={["6xl", "7xl"]} fontWeight="bold" color="#AB7D00">
          <Text>4</Text>
          <Image 
            src={error}
            alt="ring"
            bg={"transparent"}
            boxSize={["80px", "90px", "110px"]}
          />
          <Text>4</Text>
        </Stack>

        <Text fontSize={["md", "lg"]} color="gray.700">
          PAGE NOT FOUND :(
        </Text>

        <Button
          onClick={() => navigate("/")}
          bg={"#022D2D"}
          color={"white"}
          size="md"
          w="fit-content"
          mx="auto"
        >
          Back to Home
        </Button>
      </Stack>
    </Box>
  );
};

export default Error;
